import { loadStripe } from "@stripe/stripe-js";
import { createCheckoutSession } from "services/stripeService";

export type StripeCheckoutSessionParams = {
    recurring_price_id: string;
    scanner_price_id: string | null;
    store_id: string;
    customer_email?: string;
    require_cc_for_trial?: boolean;
};

type StripeCheckoutResult = {
    success: boolean;
    error?: string;
};

const getCheckoutErrorMessage = (error: any, fallback: string) => {
    if (typeof error?.detail === "string") {
        return error.detail;
    }

    if (typeof error?.message === "string") {
        return error.message;
    }

    return fallback;
};

export const launchStripeCheckout = async (
    sessionParams: StripeCheckoutSessionParams
): Promise<StripeCheckoutResult> => {
    try {
        const stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "");

        if (!stripe) {
            return {
                success: false,
                error: "Stripe failed to load",
            };
        }

        const checkoutSessionResponse = await createCheckoutSession(sessionParams);
        const sessionId = checkoutSessionResponse?.data?.session_id;

        if (!sessionId) {
            return {
                success: false,
                error: getCheckoutErrorMessage(
                    checkoutSessionResponse?.error,
                    "Unable to create checkout session"
                ),
            };
        }

        const result = await stripe.redirectToCheckout({
            sessionId,
        });

        if (result.error) {
            return {
                success: false,
                error: result.error.message || "Unable to redirect to checkout",
            };
        }

        return {
            success: true,
        };
    } catch (error: any) {
        return {
            success: false,
            error: getCheckoutErrorMessage(error, "Unable to start checkout"),
        };
    }
};
